/* eslint-disable import/no-mutable-exports */
let COST_PRICE_OPTIONS = [];
let COST_CARD_TABLE_COLLECTION_EDIT_SETTINGS = [];

const ENGLISH_OPTIONS = [
  { key: 'monthly', value: 'Monthly' },
  { key: 'yearly', value: 'Yearly' },
  { key: 'oneOff', value: 'One Off' },
  { key: 'manual', value: 'Manual' },
];

export function loadCostPriceOptions(locales) {
  const opts = locales.costRevenue.costPriceOptions;
  COST_PRICE_OPTIONS = ENGLISH_OPTIONS.map(({ key, value }) => ({
    label: opts[key],
    value,
  }));

  COST_CARD_TABLE_COLLECTION_EDIT_SETTINGS = [
    { name: 'name', type: 'text' },
    { name: 'amount', type: 'number' },
    { name: 'period', type: 'select', options: COST_PRICE_OPTIONS },
  ];
}

export { COST_PRICE_OPTIONS, COST_CARD_TABLE_COLLECTION_EDIT_SETTINGS };
export default COST_PRICE_OPTIONS;
